import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Stack, CircularProgress } from '@mui/material';
import { StoreApi } from '../../api/storeApi';
import * as notificationActions from '../../actions/notificationAction';
import useTranslation from '../../hooks/useTranslation';
import AuthStorage from '../../services/authStorage';
import { StoreProfile } from '../../shared-components';

const Auth = new AuthStorage();

const ShowStore = (props) => {
  const { t } = useTranslation();
  const storeId = Number(props.match.params.id);
  const [store, setStore] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchStore = async () => {
    try {
      setLoading(true);
      const res = await StoreApi.getStore(storeId);
      setStore(res.data);
    } catch (err) {
      props.notifyActions.setErrorNotification({ message: err.message });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchStore(); }, [storeId]);

  const storeUrl = useMemo(() => Auth.getStoreUrl(), [store]);

  if (loading) return <CircularProgress />;

  return (
    <Container maxWidth="xl">
      <Stack spacing={3} sx={{ py: 3 }}>
        <StoreProfile
          t={t}
          store={store}
          storeUrl={storeUrl}
          onEdit={() => props.history.push({ pathname: `/admin/store/general-settings`, state: { storeName: store.name } })}
          onGeneralSettings={() => props.history.push({ pathname: `/admin/store/general-settings`, state: { storeName: store.name } })}
          onPaymentSettings={() => props.history.push(`/admin/store/payment-settings`)}
          onNotificationSettings={() => props.history.push(`/admin/store/notification-settings`)}
          onAuthenticationSettings={() => props.history.push(`/admin/store/auth-settings`)}
          showSettings={{
            general: true,
            payment: true,
            notifications: true,
            authenticationSettings: true
          }}
        />
      </Stack>
    </Container>
  );
};

const mapDispatchToProps = (dispatch) => ({
  notifyActions: bindActionCreators(notificationActions, dispatch)
});

export default connect(null, mapDispatchToProps)(ShowStore);